export default {
  "nav.home": "Inicio",
  "nav.guide": "Guía completa",
  "nav.shopGuide": "Guía de compra",
  "nav.categories": "Categorías",
  "nav.faq": "Preguntas frecuentes",
  "nav.language": "Idioma",

  "announce": "Recurso independiente • Actualizado con regularidad • Verifica siempre los enlaces antes de pedir",

  "hero.badge": "Centro de recursos de USFans Spreadsheet",
  "hero.title": "USFans Spreadsheet — tu guía completa de enlaces, envíos y compras",
  "hero.subtitle": "Encuentra enlaces útiles, opiniones sinceras, detalles de envío, información de almacén y control de calidad, además de orientación sobre cupones y códigos de descuento, todo en un solo lugar claro y fácil de navegar.",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Comprar ahora",
  "hero.trust": "Fuente independiente • Actualizado recientemente • Uso seguro de enlaces",

  "dropdown.label": "Explorar categorías",
  "dropdown.placeholder": "Selecciona una categoría…",

  "categories.title": "Compra por categoría",
  "categories.subtitle": "Ve directamente a los productos que buscas en USFans.",

  "about.title": "¿Qué es la USFans Spreadsheet?",
  "about.p1": "La USFans Spreadsheet es una colección limpia y organizada de enlaces de productos y accesos directos por categoría que te ayuda a encontrar lo que buscas más rápido. En lugar de revisar páginas interminables, la hoja agrupa los artículos en categorías conocidas — zapatos, sudaderas, camisetas, chaquetas y más — para que puedas ir directo a la sección que te interesa.",
  "about.p2": "Nuestro objetivo es simple: reunir la información y los enlaces más útiles en un formato transparente y fácil de consultar. Cubrimos opiniones, costes de envío, detalles del almacén, controles de calidad, cupones y consejos de seguridad, para que puedas decidir con más confianza antes de hacer un pedido.",

  "features.title": "Todo sobre USFans en un solo lugar",
  "features.subtitle": "Seis temas esenciales para entender el servicio antes de comprar.",
  "feat.review.title": "Opinión de USFans",
  "feat.review.desc": "Conoce los puntos clave, ventajas, desventajas y detalles que conviene revisar antes de usar el servicio.",
  "feat.shipping.title": "Coste de envío de USFans",
  "feat.shipping.desc": "Descubre qué factores afectan al precio del envío y cómo comparar las opciones disponibles.",
  "feat.warehouse.title": "Almacén de USFans",
  "feat.warehouse.desc": "Aprende lo básico sobre almacenamiento, manipulación y revisión de pedidos en el almacén.",
  "feat.legit.title": "¿USFans es legítimo?",
  "feat.legit.desc": "Descubre cómo evaluar por ti mismo la fiabilidad del sitio, los enlaces y los vendedores.",
  "feat.coupon.title": "Cupón de USFans",
  "feat.coupon.desc": "Aprende a encontrar promociones y a verificar que un código de descuento siga vigente.",
  "feat.discount.title": "Código de descuento de USFans",
  "feat.discount.desc": "Aprende a comprobar la caducidad y las condiciones de un código antes de aplicarlo al pagar.",

  "why.title": "¿Por qué usar nuestra guía?",
  "why.subtitle": "Un punto de partida claro y estructurado para quien empieza con USFans.",
  "why.1": "Información organizada",
  "why.2": "Guías prácticas paso a paso",
  "why.3": "Comparaciones honestas",
  "why.4": "Detalles del control de calidad (QC)",
  "why.5": "Explicaciones sobre el envío",
  "why.6": "Recomendaciones de seguridad",
  "why.7": "Actualizaciones periódicas",
  "why.8": "Navegación sencilla",

  "articleCta.title": "¿Nuevo en USFans? Empieza por nuestra guía completa",
  "articleCta.subtitle": "Un recorrido paso a paso sobre categorías, envío, control de calidad, cupones y seguridad, pensado para principiantes.",
  "articleCta.button": "Leer la guía completa",

  "safety.title": "La seguridad es lo primero",
  "safety.text": "Verifica siempre la dirección del sitio, los enlaces, el vendedor, los precios, los métodos de pago y la información de envío antes de tomar una decisión. Este sitio es un recurso informativo independiente y no garantiza la disponibilidad, seguridad ni exactitud de servicios de terceros.",
  "safety.cta": "Visitar el Centro de Seguridad",

  "faq.title": "Preguntas frecuentes",
  "faq.1q": "¿Qué es la USFans Spreadsheet?",
  "faq.1a": "Es una colección organizada de enlaces de productos de USFans agrupados en categorías como zapatos, sudaderas, camisetas, chaquetas y accesorios, pensada para ayudarte a encontrar productos más rápido.",
  "faq.2q": "¿USFans es legítimo?",
  "faq.2a": "USFans es un servicio muy comentado, pero siempre recomendamos verificar por ti mismo los enlaces, vendedores, precios y métodos de pago antes de pedir. Ningún servicio de terceros puede considerarse seguro sin tu propia comprobación.",
  "faq.3q": "¿Cuánto cuesta el envío de USFans?",
  "faq.3a": "El coste del envío depende de varios factores, como el país de destino, el peso del paquete, el método de envío y posibles tarifas de almacén. Lo mejor es comparar las opciones disponibles al pagar.",
  "faq.4q": "¿Dónde encuentro cupones o códigos de descuento de USFans?",
  "faq.4a": "Las promociones cambian con frecuencia. Recomendamos revisar el sitio oficial directamente y verificar la fecha de caducidad y las condiciones de cada código antes de usarlo.",
  "faq.5q": "¿Cómo uso la USFans Spreadsheet?",
  "faq.5a": "Solo elige una categoría en el menú desplegable o en los botones de arriba y serás llevado directamente a la página de USFans correspondiente a ese tipo de producto.",

  "ctaBanner.title": "¿Listo para encontrar lo que buscas en USFans?",
  "ctaBanner.subtitle": "Abre la hoja y explora una colección clara y organizada de enlaces, guías y comparaciones.",
  "ctaBanner.button": "Abrir USFans Spreadsheet",

  "footer.tagline": "Un recurso informativo independiente sobre la USFans Spreadsheet.",
  "footer.disclaimer": "Este sitio web es un recurso informativo independiente y no está afiliado ni respaldado por USFans. Verifica siempre por ti mismo las URLs, vendedores, precios y servicios de terceros antes de actuar.",
  "footer.nav": "Navegación",
  "footer.resources": "Recursos",
  "footer.languages": "Idiomas",
  "footer.rights": "Todos los derechos reservados.",
  "footer.backHome": "Volver al inicio",
};